import React from 'react';

import { Typography } from '@mui/material';
import { useField, useFormikContext } from 'formik';

import Recorder from '.';

type PropsType = {
	name: string;
	hideDeleteButton?: boolean;
};

function RecorderField({ name, hideDeleteButton, ...props }: PropsType) {
	const [field, meta, helpers] = useField(name);
	const { setValue } = helpers;
	const { status } = useFormikContext();
	const handleAudioChange = (value: string | null) => {
		setValue(value);
	};

	return (
		<div>
			<Recorder
				onAudioRecord={handleAudioChange}
				value={field.value}
				hideDeleteButton={hideDeleteButton || status?.success}
				{...props}
			/>
			{meta.touched && meta.error ? (
				<Typography
					variant="caption1"
					sx={(theme) => ({ color: theme.palette.error.contrastText })}
				>
					{meta.error}
				</Typography>
			) : null}
		</div>
	);
}

export default RecorderField;
